import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { LABEL_COLOR, SERIES_OPTIONS } from '../constants';
import type { SeriesFilter } from '../types';

export const SeriesToggle = ({
    value,
    onChange,
}: {
    value: SeriesFilter;
    onChange: (value: SeriesFilter) => void;
}) => (
    <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={(_, next: SeriesFilter | null) => {
            if (next) onChange(next);
        }}
        aria-label="Series filter"
        sx={{
            bgcolor: '#F3F4F6',
            borderRadius: '10px',
            p: 0.25,
            '& .MuiToggleButtonGroup-grouped': {
                border: 0,
                borderRadius: '8px !important',
                px: 1.5,
                py: 0.25,
                textTransform: 'none',
                fontSize: 12,
                fontWeight: 600,
                color: LABEL_COLOR,
                '&.Mui-selected': {
                    bgcolor: '#fff',
                    color: '#111827',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                },
            },
        }}
    >
        {SERIES_OPTIONS.map(({ key, label }) => (
            <ToggleButton key={key} value={key}>
                {label}
            </ToggleButton>
        ))}
    </ToggleButtonGroup>
);
